import { render } from "./Seat_787.vue?vue&type=template&id=08bdd53a&scoped=true"
import script from "./Seat_787.vue?vue&type=script&lang=js"
export * from "./Seat_787.vue?vue&type=script&lang=js"

import "./Seat_787.vue?vue&type=style&index=0&id=08bdd53a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bdd53a"]])

export default __exports__